import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../angular-material-module/angular-material.module';

import { BlocklyRoutingModule } from './blockly-routing.module';
import { NgxBlocklyModule } from 'ngx-blockly';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfigToolsModule } from '../common/configTools/configTools.module';
import { BlocklyComponent } from './blockly-head/blockly.component';
import { BlocklyListComponent } from './blockly-list/blockly-list.component';
import { BlocklyEditComponent } from './blockly-edit/blockly-edit.component';

@NgModule({
  declarations: [
    BlocklyComponent,
    BlocklyListComponent,
    BlocklyEditComponent
  ],
  imports: [
    CommonModule,
    NgxBlocklyModule,
    FormsModule,
    BlocklyRoutingModule,
    ButtonModule,
    TooltipModule,
    RippleModule,
    ConfigToolsModule,
    TableModule,
    AngularMaterialModule
  ]
})
export class BlocklyModule { }
